import axiosClientFSR from "../axiosClientFSR";

export const departmentFSR = {
    get: (param) => {
        return axiosClientFSR.get('/department/list', {
            params: param
        })
    },
    delete: (id) => {
        return axiosClientFSR.delete(`/department/delete/${id}`)
    },
    add: (data) => {
        return axiosClientFSR.post(`/department/add`, data)
    },
    edit: (id, data) => {
        return axiosClientFSR.put(`/department/edit/${id}`, data)
    }

}